<footer
  class="footer container flex lg:flex-row flex-col gap-3 flex-wrap items-center justify-between py-3 pt-6"
>
  <p class="my-0 text-muted text-sm">
    © 2026 by
    <a
      class="text-muted font-medium"
      href="https://www.wrappixel.com/"
      target="_blank"
      >NIwallet</a
    >
    , creating a better web for you.
  </p>
  <div class="flex items-center gap-5">
    <a matButton class="text-muted text-sm" routerLink="/about">{{
      'pages.nav.about' | translate
    }}</a>
    <a matButton class="text-muted text-sm" routerLink="/blog">{{
      'pages.nav.blog' | translate
    }}</a>
    <a matButton class="text-muted text-sm" routerLink="/license">{{
      'pages.nav.license' | translate
    }}</a>
  </div>
</footer>
